export const requestsParams = {
    main: {
        hard: ({ creator, userId, startDate, endDate, }) => ({
            branches: [
                {
                    reasons: '1',
                    reasonsLabel: 'Spin hard purchase',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '31',
                    reasonsLabel: 'Spin golden purchase',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '32',
                    reasonsLabel: 'Spin golden reward',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '38,40,42',
                    reasonsLabel: 'Lootboxes, LIS',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '18,19',
                    reasonsLabel: 'Achievements & Daily quests, LIS',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '9,29,30',
                    reasonsLabel: 'Bingo & Tournaments, LIS',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '11,12,13,14,15,27',
                    reasonsLabel: 'Spending, LIS',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '34,35,36',
                    reasonsLabel: 'Memberships from site',
                    creators: creator,
                    userId,
                },
                {
                    reasons: '22',
                    reasonsLabel: 'LIS rewards',
                    creators: 'googlePlay',
                    userId,
                },
            ],
            startDate,
            endDate,
        }),
        rewards: ({ game, userId, startDate, endDate, }) => ({
            branches: [
                {
                    label: 'Lootboxes, LIS',
                    userId,
                    game,
                    creator: 'spin',
                    rewardType: 'lootbox',
                    extraDetails: {
                        spinTypeId: [1, 2],
                    },
                },
                {
                    label: 'Free spin rewards',
                    userId,
                    game,
                    rewardType: 'spin',
                    extraDetails: {
                        spinTypeId: [0],
                    },
                },
                {
                    label: 'Rewards from lootboxes, LIS',
                    userId,
                    game,
                    rewardType: 'lootbox',
                    creator: 'bought',
                },
                {
                    label: 'Free lootbox rewards',
                    userId,
                    game,
                    creator: 'bought',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [1],
                    },
                },
                {
                    label: 'Daily quests by memberships, LIS',
                    userId,
                    game,
                    creator: 'dailyQuest',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [2, 3, 4],
                    },
                },
            ],
            startDate,
            endDate,
        }),
        googlePlay: ({ game, startDate, endDate }) => ({
            branches: [
                {
                    productIds: ['status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'From GP (subs)',
                    game,
                },
                {
                    productIds: ['soul_buy1_gp', 'soul_buy2_gp', 'soul_buy3_gp', 'soul_buy4_gp', 'soul_buy5_gp', 'soul_buy6_gp'].join(),
                    label: 'From GP (purchases)',
                    game,
                },
                {
                    productIds: ['offer_2x_income_gp', 'offer_additional_hangar1_gp', 'offer_additional_hangar2_gp', 'offer_auto_merge_gp', 'offer_starter_pack_gp', 'offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp', 'offer_offline_earning_gp', 'offer_wall_street_card_gp', 'offer_weekly_tournament_gp', 'offer_xmas_special_gp'].join(),
                    label: 'From GP (offers)',
                    game,
                },
            ],
            convertToLis: true,
            startDate,
            endDate,
        }),
    },
    free: {
        hard: ({ userId, country, creator, startDate, endDate }) => ({
            branches: [
                {
                    reasons: '18',
                    reasonsLabel: 'Achievements, LIS',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '19',
                    reasonsLabel: 'Daily quests, LIS',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '29',
                    reasonsLabel: 'Bingo jackpot, LIS',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '30',
                    reasonsLabel: 'Bingo rewards, LIS',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '9',
                    reasonsLabel: 'Tournaments, LIS',
                    creators: creator,
                    country,
                    userId,
                },
            ],
            startDate,
            endDate,
        }),
        rewards: ({ userId, game, startDate, endDate }) => ({
            branches: [
                {
                    label: 'Free spin rewards',
                    userId,
                    game,
                    rewardType: 'spin',
                    extraDetails: {
                        spinTypeId: [0],
                    },
                },
                {
                    label: 'Free lootbox rewards',
                    userId,
                    game,
                    creator: 'bought',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [1],
                    },
                },
            ],
            startDate,
            endDate,
        }),
    },
    spins: {
        hard: ({ country, creator, userId, startDate, endDate, }) => ({
            branches: [
                {
                    reasons: '1',
                    reasonsLabel: 'Spin hard purchase',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '31',
                    reasonsLabel: 'Spin golden purchase',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '32',
                    reasonsLabel: 'Spin golden reward',
                    creators: creator,
                    country,
                    userId,
                },
            ],
            startDate,
            endDate,
        }),
        rewards: ({ game, userId, startDate, endDate, }) => ({
            branches: [
                {
                    label: 'Lootboxes, LIS',
                    userId,
                    game,
                    creator: 'spin',
                    rewardType: 'lootbox',
                    extraDetails: {
                        spinTypeId: [1, 2],
                    },
                },
            ],
            startDate,
            endDate,
        }),
    },
    lootboxes: {
        hard: ({ creator, userId, startDate, endDate }) => ({
            branches: [
                {
                    reasons: '38,40,42',
                    reasonsLabel: 'Purchases, LIS',
                    creators: creator,
                    userId,
                },
            ],
            startDate,
            endDate,
        }),
        rewards: ({ game, userId, startDate, endDate }) => ({
            branches: [
                {
                    label: 'Rewards, LIS',
                    userId,
                    game,
                    rewardType: 'lootbox',
                    creator: 'bought',
                    extraDetails: {},
                },
            ],
            startDate,
            endDate,
        }),
    },
    spending: ({ creator, country, userId, startDate, endDate }) => ({
        branches: [
            {
                reasons: '15',
                reasonsLabel: 'Buy unit',
                creators: creator,
                country,
                userId,
            },
            {
                reasons: '11',
                reasonsLabel: 'Upgrade unit',
                creators: creator,
                country,
                userId,
            },
            {
                reasons: '12',
                reasonsLabel: 'Airdrop',
                creators: creator,
                country,
                userId,
            },
            {
                reasons: '13',
                reasonsLabel: 'x3 (Offline earning)',
                creators: creator,
                country,
                userId,
            },
            {
                reasons: '14',
                reasonsLabel: 'Speed boost',
                creators: creator,
                country,
                userId,
            },
            {
                reasons: '27',
                reasonsLabel: 'Science',
                creators: creator,
                country,
                userId,
            },
        ],
        startDate,
        endDate,
    }),
    status: {
        hard: ({ creator, country, userId, startDate, endDate }) => ({
            branches: [
                {
                    reasons: '34',
                    reasonsLabel: 'Silver',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '35',
                    reasonsLabel: 'Gold',
                    creators: creator,
                    country,
                    userId,
                },
                {
                    reasons: '36',
                    reasonsLabel: 'Platinum',
                    creators: creator,
                    country,
                    userId,
                },
            ],
            startDate,
            endDate,
        }),
        rewards: ({ game, userId, startDate, endDate }) => ({
            branches: [
                {
                    label: 'Iron lootboxes, LIS',
                    userId,
                    game,
                    creator: 'dailyQuest',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [2],
                    },
                },
                {
                    label: 'Gold lootboxes, LIS',
                    userId,
                    game,
                    creator: 'dailyQuest',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [3],
                    },
                },
                {
                    label: 'Platinum lootboxes, LIS',
                    userId,
                    game,
                    creator: 'dailyQuest',
                    rewardType: 'lootbox',
                    extraDetails: {
                        lootboxId: [4],
                    },
                },
            ],
            startDate,
            endDate,
        }),
        googlePlay: ({ game, country, startDate, endDate }) => ({
            branches: [
                {
                    productIds: ['status_buy3_gp', 'status_buy4_gp', 'status_buy5_gp'].join(),
                    label: 'From GP',
                    game,
                    country,
                },
            ],
            convertToLis: true,
            startDate,
            endDate,
        }),
    },
    googlePlay: {
        all: {
            all: (countrySign, game) => [
                {
                    productIds: ['soul_buy1_gp', 'soul_buy2_gp', 'soul_buy3_gp', 'soul_buy4_gp', 'soul_buy5_gp', 'soul_buy6_gp'].join(),
                    label: 'LIS',
                    game,
                    country: countrySign,
                },
                {
                    productIds: ['offer_2x_income_gp', 'offer_additional_hangar1_gp', 'offer_additional_hangar2_gp', 'offer_auto_merge_gp', 'offer_starter_pack_gp', 'offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp', 'offer_offline_earning_gp', 'offer_wall_street_card_gp', 'offer_weekly_tournament_gp', 'offer_xmas_special_gp'].join(),
                    label: 'Offers',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'status_buy3_gp,status_buy4_gp,status_buy5_gp',
                    label: 'Memberships',
                    game,
                    country: countrySign,
                },
            ],
            lis: (countrySign, game) => [
                {
                    productIds: 'soul_buy1_gp',
                    label: 'LIS - 1',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'soul_buy2_gp',
                    label: 'LIS - 2',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'soul_buy3_gp',
                    label: 'LIS - 3',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'soul_buy4_gp',
                    label: 'LIS - 4',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'soul_buy5_gp',
                    label: 'LIS - 5',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'soul_buy6_gp',
                    label: 'LIS - 6',
                    game,
                    country: countrySign,
                },
            ],
            offers: {
                all: (countrySign, game) => [
                    {
                        productIds: 'offer_2x_income_gp',
                        label: '2X',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: ['offer_additional_hangar1_gp', 'offer_additional_hangar2_gp'].join(),
                        label: 'Hangar',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_auto_merge_gp',
                        label: 'Auto merge',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: ['offer_last_chance_gp', 'offer_last_chance2_gp', 'offer_last_chance3_gp', 'offer_last_chance4_gp'].join(),
                        label: 'Last chance',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_offline_earning_gp',
                        label: 'Offline earning',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_starter_pack_gp',
                        label: 'Starter pack',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_wall_street_card_gp',
                        label: 'Wall street',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_weekly_tournament_gp',
                        label: 'Weekly tournament',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_xmas_special_gp',
                        label: 'Xmas',
                        game,
                        country: countrySign,
                    },
                ],
                hangar: (countrySign, game) => [
                    {
                        productIds: 'offer_additional_hangar1_gp',
                        label: 'Hangar - 1',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_additional_hangar2_gp',
                        label: 'Hangar - 2',
                        game,
                        country: countrySign,
                    },
                ],
                lastChance: (countrySign, game) => [
                    {
                        productIds: 'offer_last_chance_gp',
                        label: 'Last chance - 1',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_last_chance2_gp',
                        label: 'Last chance - 2',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_last_chance3_gp',
                        label: 'Last chance - 3',
                        game,
                        country: countrySign,
                    },
                    {
                        productIds: 'offer_last_chance4_gp',
                        label: 'Last chance - 4',
                        game,
                        country: countrySign,
                    },
                ],
            },
            memberships: (countrySign, game) => [
                {
                    productIds: 'status_buy3_gp',
                    label: 'Silver',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'status_buy4_gp',
                    label: 'Golden',
                    game,
                    country: countrySign,
                },
                {
                    productIds: 'status_buy5_gp',
                    label: 'Platinum',
                    game,
                    country: countrySign,
                },
            ],
        },
    },
};
